// extracted by mini-css-extract-plugin
export default {"alertTemplate":"alert_alertTemplate__u+C5I","closeX":"alert_closeX__Vwyrj","error":"alert_error__QmrNN","success":"alert_success__AL2O9"};